import React, {useEffect, useState} from 'react';
import icon120 from './Image/icon-120.svg';

const LeadSuccess = (props) => {
  useEffect(() => {
    if (props.onSubmit) {
      props.onValid({isValid: true});
    }
  }, [props.onSubmit]);

  return (
    <div className='lead-success-status'>
      <div className='image-position' style={{backgroundImage:icon120.bg()}}></div>
      <div className='text-of-success'>
        תודה, נציג יחזור אליך
        <br />
        מוקדם ככל האפשר!
      </div>
    </div>
  );
};

export default LeadSuccess;
